/** @typedef {import('@mantine/core').MantineThemeOverride} MantineThemeOverride */
/** @typedef {NonNullable<MantineThemeOverride['components']>['Loader']} LoaderTheme */

/** @type {LoaderTheme} */
export const Loader = {};
